var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.154 28.6667C8.29067 28.6667 7.54922 28.377 6.92967 27.7974C6.30989 27.2181 6 26.501 6 25.6461V7.44373C6 6.67618 6.24833 5.9954 6.745 5.4014C7.24144 4.8074 7.87344 4.43007 8.641 4.2694L21.077 1.7334V22.1437L8.854 24.6897C8.61978 24.7428 8.41889 24.857 8.25133 25.0321C8.08378 25.2074 8 25.4121 8 25.6461C8 25.9418 8.115 26.186 8.345 26.3784C8.57478 26.5706 8.84444 26.6667 9.154 26.6667H24V6.00007H26V28.6667H9.154ZM11.5897 22.1054L19.077 20.5487V4.1924L11.5897 5.72307V22.1054ZM9.58967 22.5104V6.1284L9.05133 6.24106C8.74711 6.30262 8.49578 6.4424 8.29733 6.6604C8.09911 6.8784 8 7.13951 8 7.44373V22.9721C8.13667 22.9018 8.27689 22.8415 8.42067 22.7911C8.56422 22.7406 8.70867 22.7001 8.854 22.6694L9.58967 22.5104Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.de205e596d324bff1ce4929021e78781.svg";
export { ForwardRef as ReactComponent };